import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

//if (process.env.NODE_ENV === 'production') {
  //console.log = console.warn = () => {};
//}


console.log('index.js is running');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log('App has been rendered');
